/**
 * Returns the content styles CSS string for variable elements
 */
export const getContentStyles = (): string => {
  return (
    '@import url("https://fonts.googleapis.com/css?family=Source+Sans+Pro:200,200i,300,300i,400,400i,600,600i,700,700i,900,900i&display=swap");' +
    "html { height: 100% !important; display: flex;}" +
    'body { font-family: "Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif; font-size: 14px; width: 100%; line-height: 1.5em}' +
    "p {margin: 0}" +
    ".mce-content-body[data-mce-placeholder]:not(.mce-visualblocks)::before { color: rgba(0, 0, 0, 0.3); cursor: text; }" +
    ".template-variable-description { color: #666; font-size: 0.9em; font-style: italic; }" +
    ".bbj-var, .bbj-var-field { color: #086BE6; font-weight: 700; }"
  );
};

/**
 * Returns the CSS string for dropdown menu styling
 */
export const getMenuStyles = (): string => {
  return `
    /* TinyMCE menu item: first line = label; following lines = description */
    .tox .tox-collection__item-label {
      white-space: pre-line;
      color: #666;
      line-height: 1.2;
      font-size: 13px !important;
    }
    .tox .tox-collection__item-label::first-line {
      color: #111;
      font-style: normal;
      font-weight: normal;
    }
    
    /* Style for separator headers (group headings) */
    .tox .tox-collection__group-heading {
      font-weight: bold !important;
      font-size: 14px !important;
      color: #333 !important;
      background-color: white !important;
      padding: 8px 8px 0px 8px !important;
    }
  `;
};

/**
 * Injects menu styles into the document head
 */
export const injectMenuStyles = (): void => {
  const style = document.createElement("style");
  style.textContent = getMenuStyles();
  document.head.appendChild(style);
};
